import { graphql } from "@/gql";

export const cityNameQuery = graphql(`
  query CityName($id: ID!) {
    city(id: $id) {
      id
      name
      region
      state
    }
  }
`);
